import styles from '../Tabelas.module.css'
import Container from '../../../../components/components-ui/Container/Container'
import { Table } from '../../../../components/Table'
import Button from '../../../../components/components-ui/Button/Button'
import { Link } from 'react-router-dom'
import { useEffect, useState } from 'react'
import api from '../../../../services/Api'
import Loading from '../../../../components/components-ui/Loading/Loading'

export default function Acao() {
  const [acao, setAcao] = useState([])
  const [showLoading, setShowLoading] = useState(false)

  useEffect(() => {
    async function getAcao() {
      setShowLoading(true)
      const response = await api.get('/acao/index')
      setAcao(response.data)
      setShowLoading(false)
    }
    getAcao()
  }, [])

  // Colunas da tabela
  const columns = [
    {
      column: 'Ação',
    },
  ]

  return (
    <Container>
      <h3>Listagem de Ações</h3>
      <Link to="/usina/acao/novo/" style={{ display: "contents" }}>
        <Button title="Novo" type="button" />
      </Link>

      <div className={styles.content}>
        <Table edit columns={columns}>
          {acao.map(
            ({ Acao, IdAcao }) => (
              <tr key={IdAcao}>
                <td>
                  <Link
                    to={`/usina/acao/edit/${IdAcao}`}
                  >
                    <i className="fas fa-pencil-alt"></i>
                  </Link>
                </td>
                <td>{Acao}</td>
              </tr>
            )
          )}
        </Table>
        <div className={styles.loading}>
          <Loading display={showLoading ? 'block' : 'none'} />
        </div>
      </div>
    </Container>
  )
}
